import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";
import { REPORT_NAME } from "../../constant/reportType";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Table } from "antd";
import { BsFileEarmarkText, BsStarFill, BsZoomIn, BsZoomOut } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import { PDF_LIBRARY_COLULMN } from "../../constant/AppConstant";
import { allPdfRecordDetails, pdfRecordTotalRecords, setPdfReords } from "../../redux-toolkit/slices/pdfSlice";
import { useDownloadPdfMutation, useGetPdfRecordsMutation } from "../../redux-toolkit/services/pdfService";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import HTMLFlipBook from "react-pageflip";
import "./pdfLibrary.scss"
import { useDeleteFavouriteByIdMutation, useGetAllFavouritesMutation, useGetFavouriteByUserIdMutation, useSaveFavouriteMutation } from "../../redux-toolkit/services/favouritesService";
import { getUserFavourites, setFavouritesByUser } from "../../redux-toolkit/slices/favouriteSlice";

// Set the workerSrc to the local worker script
GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

type TextItem = {
    str: string;
    width: number;
    height: number;
    transform: number[];
};

type PageData = {
    image: string;
    text: string;
    textItems: TextItem[];
    viewport: {
        width: number;
        height: number;
    };
};

type Props = {};
const PDFLibrary = (props: Props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");
    const flipBookRef = useRef<any>(null); // Ref to control the flipbook
    const inputRef = useRef<HTMLInputElement>(null);
    const canvasRefs = useRef<(HTMLCanvasElement | null)[]>([]);

    //state
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [showPdfViewer, setShowPdfViewer] = useState(false); // for PDF viewer
    const [selectedPdf, setSelectedPdf] = useState<any>(null); // for selected PDF
    const [pdfBlob, setPdfBlob]: any = useState(); // State for PDF blob
    const [currentFlipPage, setCurrentFlipPage] = useState(0); // Track current page
    const [searchQuery, setSearchQuery] = useState(""); // for search query
    const [searchResults, setSearchResults] = useState<number[]>([]); // Pages with search matches
    const [currentSearchIndex, setCurrentSearchIndex] = useState(-1); // Current match index
    const [isMaximized, setIsMaximized] = useState(false); // for maximize/minimize
    const [isLoadingPages, setIsLoadingPages] = useState(false); // New state for loading
    const [isFlipBookReady, setIsFlipBookReady] = useState(false);
    const [pagesData, setPagesData] = useState<PageData[]>([]);
    const [zoomLevel, setZoomLevel] = useState(1); // Zoom level (1 = 100%)
    const [favorites, setFavorites] = useState<Set<number>>(new Set()); // Track favorited PDFs by datarecordid

    const [baseWidth, setBaseWidth] = useState(1000);
    const [baseHeight, setBaseHeight] = useState(1000);

    //getMutations
    const [getAllPdfRecord, allPdfRecordResponse] = useGetPdfRecordsMutation();
    const [getFavourites, favouritesResponse] = useGetAllFavouritesMutation();
    const [getFavouritesByUser, favouritesByUserResponse] = useGetFavouriteByUserIdMutation();
    const [saveFavourite, saveFavouriteResponse] = useSaveFavouriteMutation();
    const [deleteFavourite, deleteFavouriteResponse] = useDeleteFavouriteByIdMutation();
    const [downloadPdf, downloadPdfResponse] = useDownloadPdfMutation();

    //totalRecords
    const totalPdfRecords = useAppSelector(pdfRecordTotalRecords);
    const allPdfRecords: any = useAppSelector(allPdfRecordDetails)
    const favouritesByUser: any = useAppSelector(getUserFavourites);

    useEffect(() => {
        setReportName(REPORT_NAME.PDF_LIBRARY);
    }, []);

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {

                const handleViewDocument = () => {
                    setSelectedPdf(record); // Set the selected PDF
                    setShowPdfViewer(true); // Open the PDF viewer
                }

                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        {reportName === REPORT_NAME.PDF_LIBRARY && (
                            <div>
                                <Button
                                    variant="primary"
                                    className="d-flex align-items-center mx-2"
                                    onClick={handleViewDocument}
                                >
                                    <BsFileEarmarkText size={16} onClick={handleViewDocument} />
                                </Button>
                            </div>
                        )}
                    </div>
                );
            },
        };

        // New Favorites column with a star button
        const tempFavorites: any = {
            title: "Favorite",
            dataIndex: "favorite",
            key: "favorite",
            fixed: "right",
            width: 100,
            render: (index: any, record: any) => {
                const pdfrecordid = record.id; // This is the pdfRecordId of the PdfRecord
                const isFavorited = favorites.has(pdfrecordid); // Check if pdfRecordId is in favorites Set

                return (
                    <div>
                        <Button
                            variant="outline-warning"
                            onClick={() => handleToggleFavorite(record)}
                            style={{ padding: "2px 8px" }}
                        >
                            <BsStarFill
                                size={16}
                                style={{
                                    color: isFavorited ? "#ffc107" : "gray",
                                }}
                            />
                        </Button>
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.PDF_LIBRARY && PDF_LIBRARY_COLULMN) {
            PDF_LIBRARY_COLULMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempFavorites); // Add Favorites column
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType, favorites]);

    useEffect(() => {
        if (reportName === REPORT_NAME.PDF_LIBRARY) {
            getAllPdfRecord({
                page: currentpage - 1,
                size: pageSize,
                sort: "id",
            });
            getFavouritesByUser({
                userId: localUserObj?.id
            })
        }
    }, [reportName]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.PDF_LIBRARY) {
            getAllPdfRecord({
                page: page - 1,
                size: pageSize,
                sort: "id",
            });
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleSearch = () => {
        const value = inputRef.current?.value;
        console.log("Search text:", value);
        if (reportName === REPORT_NAME.PDF_LIBRARY) {
            getAllPdfRecord({
                page: currentpage - 1,
                size: pageSize,
                sort: "id",
                keyword: value
            });
        }
    };

    // Handle toggling a PDF as a favorite
    const handleToggleFavorite = (record: any) => {
        const pdfRecordId = record.id
        const datarecordId = record.dataRecordId;
        const isFavorited = favorites.has(pdfRecordId);

        // Find the favouriteId from userFavorites
        const favourite = favouritesByUser?.find((fav: any) => fav.pdfRecordId === pdfRecordId);
        const favouriteId = favourite?.id;

        // Simulate adding/removing from favorites table
        const favoriteRecord = {
            userId: localUserObj?.id, // Replace with actual user ID from token
            datarecordId: datarecordId,
            pdfRecordId: pdfRecordId,
            pdfTitle: record.title || "unknown", // Adjust based on your record structure
            pdfUrl: record.driveUrl || "", // Use the driveUrl from the record
        };

        if (isFavorited) {
            // Remove from favorites
            const newFavorites = new Set(favorites);
            newFavorites.delete(pdfRecordId);
            setFavorites(newFavorites);
            console.log(`Removed from favorites:`, favoriteRecord);
            // Here, an API to remove the record from the favorites table
            deleteFavourite({
                id: parseInt(favouriteId),
            })
        } else {
            // Add to favorites
            const newFavorites = new Set(favorites);
            newFavorites.add(pdfRecordId);
            setFavorites(newFavorites);
            console.log(`Added to favorites:`, favoriteRecord);
            saveFavourite({
                payload: {
                    isActive: true,
                    userId: parseInt(localUserObj?.id),
                    dataRecordId: datarecordId,
                    pdfRecordId: pdfRecordId,
                    pdfTitle: record.title,
                    pdfUrl: record.driveUrl
                },
            })
            // Here, you would typically call an API to add the record to the favorites table
            // e.g., addFavorite(favoriteRecord);
        }
    };

    // Calculate dimensions based on zoom level
    // const getFlipbookDimensions = useCallback(() => {
    //     const step = Math.round((zoomLevel - 1) / 0.25); // e.g., 0 => 1, 1 => 2, etc.
    //     const widthIncrement = 200 * (step + 1);
    //     const heightIncrement = 400 * (step + 1);

    //     if (isMaximized) {
    //         return {
    //             width: (window.innerWidth - 40) * zoomLevel,
    //             height: (window.innerHeight - 150) * zoomLevel,
    //         };
    //     }

    //     return {
    //         width: baseWidth * zoomLevel,
    //         height: baseHeight * zoomLevel,
    //     };
    // }, [isMaximized, zoomLevel]);

    const getFlipbookDimensions = useCallback(() => {
        if (isMaximized) {
            return {
                width: (window.innerWidth - 40) * zoomLevel,
                height: (window.innerHeight - 150) * zoomLevel,
            };
        }
        return {
            width: (baseWidth + 600) * zoomLevel,
            height: (baseHeight + 600) * zoomLevel,
        };
    }, [baseWidth, baseHeight, zoomLevel]);

    // Update highlights when search results, query, or zoom changes
    useEffect(() => {
        canvasRefs.current.forEach((canvas, index) => {
            if (canvas) {
                const ctx = canvas.getContext("2d");
                if (ctx) {
                    // Clear the canvas
                    ctx.clearRect(0, 0, canvas.width, canvas.height);

                    if (searchResults.includes(index) && searchQuery && pagesData.length > 0) {
                        const pageData = pagesData[index];
                        const { width, height } = pageData.viewport;

                        // Calculate scaling factors
                        const scaleX = (baseWidth * zoomLevel) / width;
                        const scaleY = (baseHeight * zoomLevel) / height;

                        const query = searchQuery.toLowerCase().trim();
                        console.log(`Processing highlights for page ${index}, query: "${query}"`);
                        console.log(`Page ${index} text items:`, pageData.textItems);

                        let hasHighlighted = false;
                        pageData.textItems.forEach((item, itemIndex) => {
                            console.log(`Checking text item ${itemIndex}: "${item.str}"`);
                            if (item.str.includes(query)) {
                                const x = item.transform[4] * scaleX;
                                // const y = (height - item.transform[5]) * scaleY;
                                const y = (height - item.transform[5]) * scaleY - (item.height / 2);
                                const itemWidth = item.width * scaleX;
                                const itemHeight = item.height * scaleY;

                                ctx.fillStyle =
                                    currentSearchIndex === searchResults.indexOf(index)
                                        ? "rgba(255, 0, 0, 0.5)" // Red for current match
                                        : "rgba(255, 255, 0, 0.5)"; // Yellow for other matches
                                ctx.fillRect(x, y, itemWidth, itemHeight);

                                console.log(`Highlighting on page ${index}:`, {
                                    query,
                                    str: item.str,
                                    x,
                                    y: y - itemHeight,
                                    width: itemWidth,
                                    height: itemHeight,
                                    color: ctx.fillStyle,
                                });
                                hasHighlighted = true;
                                // // Fallback: If no text items match, highlight the entire page
                                // if (!hasHighlighted && pageData.text.includes(query)) {
                                //     console.log(`No matching text items found on page ${index}, applying fallback highlight`);
                                //     ctx.fillStyle =
                                //         currentSearchIndex === searchResults.indexOf(index)
                                //             ? "rgba(255, 0, 0, 0.2)"
                                //             : "rgba(255, 255, 0, 0.2)";
                                //     ctx.fillRect(0, 0, baseWidth * zoomLevel, baseHeight * zoomLevel);
                                // }
                            }
                        });
                    }
                }
            }
        });
    }, [searchResults, searchQuery, pagesData, currentSearchIndex, zoomLevel]);

    // Fetch PDF content from backend
    useEffect(() => {
        if (!selectedPdf || !selectedPdf.driveUrl) {
            setPdfBlob(null);
            setPagesData([]);
            setIsLoadingPages(false);
            setIsFlipBookReady(false);
            setZoomLevel(1);
            return;
        }

        const fileId = selectedPdf.driveUrl.match(/\/d\/([^/]+)/)?.[1];
        if (!fileId) {
            console.error("Invalid Google Drive URL:", selectedPdf.driveUrl);
            setIsLoadingPages(false);
            return;
        }

        setIsLoadingPages(true);
        downloadPdf(fileId)
            .unwrap()
            .then(async (response: any) => {
                const blob = new Blob([response], { type: "application/pdf" });
                const url = URL.createObjectURL(blob);
                setPdfBlob(url);

                // Load PDF and extract pages as images and text with positions
                const loadingTask = getDocument(url);
                const pdf = await loadingTask.promise;
                const numPages = pdf.numPages;
                const pages: PageData[] = [];

                console.log(`Total pages in PDF: ${numPages}`);

                const scale = 1.0; // Same scale as used in viewport

                for (let i = 1; i <= numPages; i++) {
                    const page = await pdf.getPage(i);
                    const viewport = page.getViewport({ scale });

                    if (i === 1) {
                        setBaseWidth(viewport.width);
                        setBaseHeight(viewport.height);
                    }

                    // Render page to image
                    const canvas = document.createElement("canvas");
                    const context = canvas.getContext("2d");
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    await page.render({
                        canvasContext: context!,
                        viewport,
                    }).promise;

                    const image = canvas.toDataURL("image/png");

                    // Extract text and positions
                    const textContent = await page.getTextContent();
                    const pageText = textContent.items
                        .map((item: any) => item.str || "")
                        .join(" ")
                        .trim();

                    const textItems: TextItem[] = textContent.items
                        .filter((item: any) => item.str && item.str.trim())
                        .map((item: any) => ({
                            str: item.str.toLowerCase().trim(),
                            width: item.width * scale,
                            height: item.height * scale,
                            transform: item.transform.map((val: number) => val * scale),
                        }));

                    console.log(`Page ${i} text:`, pageText);
                    console.log(`Page ${i} text items:`, textItems);

                    pages.push({
                        image,
                        text: pageText.toLowerCase(),
                        textItems,
                        viewport: {
                            width: viewport.width,
                            height: viewport.height,
                        },
                    });
                }

                console.log("Extracted pages data:", pages);
                setPagesData(pages);
                setIsLoadingPages(false);
            })
            .catch((error: any) => {
                console.error("Failed to load PDF:", error);
                setIsLoadingPages(false);
                alertMessage("Failed to load PDF.", "error");
            });
    }, [selectedPdf, downloadPdf]);

    // Check if flipBookRef is ready after pagesData is loaded
    useEffect(() => {
        if (pagesData.length > 0 && flipBookRef.current) {
            let attempts = 0;
            const maxAttempts = 50; // 5 seconds (50 * 100ms)

            const checkFlipBookReady = () => {
                attempts++;
                const pageFlipInstance = flipBookRef.current.pageFlip();
                if (pageFlipInstance && typeof pageFlipInstance.flip === "function") {
                    console.log("FlipBook is ready after", attempts, "attempts!");
                    setIsFlipBookReady(true);
                } else if (attempts >= maxAttempts) {
                    console.warn("Max attempts reached. Using fallback navigation.");
                    setIsFlipBookReady(true); // Allow fallback navigation
                } else {
                    console.log("FlipBook not ready yet, attempt", attempts);
                    setTimeout(checkFlipBookReady, 100); // Retry after 100ms
                }
            };

            console.log("Starting FlipBook readiness check...");
            checkFlipBookReady();
        }

        // Cleanup on unmount
        return () => {
            setIsFlipBookReady(false);
        };
    }, [pagesData]);

    // Force FlipBook to update when zoomLevel changes
    useEffect(() => {
        if (flipBookRef.current && isFlipBookReady) {
            const pageFlipInstance = flipBookRef.current.pageFlip();
            if (pageFlipInstance && typeof pageFlipInstance.updateFrom === "function") {
                console.log("Updating FlipBook dimensions for zoomLevel:", zoomLevel);
                pageFlipInstance.update();
            }
        }
    }, [zoomLevel, isFlipBookReady]);

    const closePdfViewer = () => {
        setShowPdfViewer(false);
        setSelectedPdf(null);
        setPdfBlob(null);
        setPagesData([]);
        setSearchQuery("");
        setSearchResults([]);
        setCurrentSearchIndex(-1);
        setIsMaximized(false);
        setIsLoadingPages(false);
        setIsFlipBookReady(false);
        setZoomLevel(1);
        URL.revokeObjectURL(pdfBlob || "");
    };

    // Search functionality
    const handleSearchInPdf = () => {
        if (!searchQuery) {
            setSearchResults([]);
            setCurrentSearchIndex(-1);
            alertMessage("Please enter a search term.", "warning");
            return;
        }

        if (isLoadingPages) {
            alertMessage("Please wait, PDF pages are still loading.", "warning");
            return;
        }

        if (pagesData.length === 0) {
            alertMessage("PDF pages are not loaded yet.", "error");
            return;
        }

        if (!isFlipBookReady) {
            alertMessage("FlipBook is not ready yet. Please wait.", "warning");
            return;
        }

        const query = searchQuery.toLowerCase().trim();
        console.log("Searching for:", query);
        console.log("Pages data:", pagesData);

        const results: number[] = [];
        pagesData.forEach((page, index) => {
            if (page.text.includes(query)) {
                results.push(index);
            }
        });

        console.log("Search results (page indices):", results);

        if (results.length === 0) {
            alertMessage("No matches found.", "info");
        } else {
            alertMessage(`${results.length} match(es) found.`, "success");
        }

        setSearchResults(results);
        setCurrentSearchIndex(results.length > 0 ? 0 : -1);

        if (results.length > 0) {
            const pageToJump = results[0];
            console.log("Jumping to page:", pageToJump);
            if (flipBookRef.current && typeof flipBookRef.current.pageFlip === "function") {
                const pageFlipInstance = flipBookRef.current.pageFlip();
                if (pageFlipInstance && typeof pageFlipInstance.flip === "function") {
                    pageFlipInstance.flip(pageToJump);
                    setCurrentFlipPage(pageToJump);
                } else {
                    // Fallback: Update startPage as a fallback navigation method
                    console.warn("PageFlip instance not ready, using fallback navigation");
                    setCurrentFlipPage(pageToJump);
                }
            } else {
                console.error("Flipbook ref not ready or pageFlip not available");
                alertMessage("Flipbook not ready. Please try again.", "error");
            }
        }
    };

    // Navigate to next/previous search result
    const handleNextSearchResult = () => {
        if (searchResults.length === 0) return;
        const nextIndex = (currentSearchIndex + 1) % searchResults.length;
        setCurrentSearchIndex(nextIndex);
        const pageToJump = searchResults[nextIndex];
        console.log("Next search result, jumping to page:", pageToJump);
        if (flipBookRef.current && typeof flipBookRef.current.pageFlip === "function") {
            const pageFlipInstance = flipBookRef.current.pageFlip();
            if (pageFlipInstance && typeof pageFlipInstance.flip === "function") {
                pageFlipInstance.flip(pageToJump);
                setCurrentFlipPage(pageToJump);
            } else {
                // Fallback
                setCurrentFlipPage(pageToJump);
            }
        }
    };

    const handlePrevSearchResult = () => {
        if (searchResults.length === 0) return;
        const prevIndex = (currentSearchIndex - 1 + searchResults.length) % searchResults.length;
        setCurrentSearchIndex(prevIndex);
        const pageToJump = searchResults[prevIndex];
        console.log("Previous search result, jumping to page:", pageToJump);
        if (flipBookRef.current && typeof flipBookRef.current.pageFlip === "function") {
            const pageFlipInstance = flipBookRef.current.pageFlip();
            if (pageFlipInstance && typeof pageFlipInstance.flip === "function") {
                pageFlipInstance.flip(pageToJump);
                setCurrentFlipPage(pageToJump);
            } else {
                // Fallback
                setCurrentFlipPage(pageToJump);
            }
        }
    };

    // Navigation functions for the flipbook
    const handlePrevPage = () => {
        if (flipBookRef.current && typeof flipBookRef.current.pageFlip === "function") {
            const pageFlipInstance = flipBookRef.current.pageFlip();
            if (pageFlipInstance && typeof pageFlipInstance.flipPrev === "function") {
                pageFlipInstance.flipPrev();
            } else {
                // Fallback
                if (currentFlipPage > 0) {
                    setCurrentFlipPage(currentFlipPage - 1);
                }
            }
        }
    };

    const handleNextPage = () => {
        if (flipBookRef.current && typeof flipBookRef.current.pageFlip === "function") {
            const pageFlipInstance = flipBookRef.current.pageFlip();
            if (pageFlipInstance && typeof pageFlipInstance.flipNext === "function") {
                pageFlipInstance.flipNext();
            } else {
                // Fallback
                if (currentFlipPage < pagesData.length - 1) {
                    setCurrentFlipPage(currentFlipPage + 1);
                }
            }
        }
    };

    const handleZoomIn = () => {
        const newZoom = Math.min(zoomLevel + 0.25, 3);
        setZoomLevel(newZoom);
        console.log("Zooming in, new zoom level:", newZoom);
    };

    const handleZoomOut = () => {
        const newZoom = Math.max(zoomLevel - 0.25, 0.5);
        setZoomLevel(newZoom);
        console.log("Zooming out, new zoom level:", newZoom);
    };

    const toggleMaximize = () => {
        setIsMaximized((prev) => !prev);
    };

    useEffect(() => {
        if (allPdfRecordResponse.isSuccess) {
            dispatch(setPdfReords(allPdfRecordResponse));
        } else if (allPdfRecordResponse.isError) {
            let response: any = allPdfRecordResponse.error;
            alertMessage(response, "error");
        }
    }, [allPdfRecordResponse.isSuccess, allPdfRecordResponse.isError]);

    useEffect(() => {
        if (allPdfRecords && reportName === REPORT_NAME.PDF_LIBRARY) {
            setDatasource(allPdfRecords);
        }
    }, [allPdfRecords]);

    useEffect(() => {
        if (saveFavouriteResponse.isSuccess) {
            console.log(saveFavouriteResponse)
            getFavouritesByUser({ userId: localUserObj?.id });
        } else if (saveFavouriteResponse.isError) {
            let response: any = saveFavouriteResponse.error;
            alertMessage(response, "error");
        }
    }, [saveFavouriteResponse.isSuccess, saveFavouriteResponse.isError]);

    useEffect(() => {
        if (deleteFavouriteResponse.isSuccess) {
            alertMessage("Removed From Favourites", "success");
            getFavouritesByUser({ userId: localUserObj?.id });
        } else if (deleteFavouriteResponse.isError) {
            alertMessage("Error while removing from favourites", "error");
        }
    }, [deleteFavouriteResponse.isSuccess, deleteFavouriteResponse.isError]);

    useEffect(() => {
        if (favouritesByUserResponse.isSuccess) {
            console.log(favouritesByUserResponse)
            const favoritePdfRecordIds: any = new Set((favouritesByUserResponse.data).map((fav: any) => fav.pdfRecordId));
            setFavorites(favoritePdfRecordIds);
            dispatch(setFavouritesByUser(favouritesByUserResponse));
        } else if (favouritesByUserResponse.isError) {
            let response: any = favouritesByUserResponse.error;
            alertMessage(response, "error");
        }
    }, [favouritesByUserResponse.isSuccess, favouritesByUserResponse.isError]);

    useEffect(() => {
        if (favouritesByUser && reportName === REPORT_NAME.PDF_LIBRARY) {
            // setDatasource(favouritesByUser);
            console.log(favouritesByUser)
        }
    }, [favouritesByUser]);


    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                console.log("Tab is hidden, possible screenshot attempt");
                // Optionally, blur or hide content
                setShowPdfViewer(false); // Aggressive approach
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    }, []);

    useEffect(() => {
        const handleBeforePrint = () => {
            console.log("Print attempt detected");
            setShowPdfViewer(false); // Close the modal to prevent printing
        };

        const handleAfterPrint = () => {
            console.log("Print dialog closed");
        };

        window.addEventListener("beforeprint", handleBeforePrint);
        window.addEventListener("afterprint", handleAfterPrint);

        return () => {
            window.removeEventListener("beforeprint", handleBeforePrint);
            window.removeEventListener("afterprint", handleAfterPrint);
        };
    }, []);

    useEffect(() => {
        if (flipBookRef.current && typeof flipBookRef.current.pageFlip === "function") {
            const instance = flipBookRef.current.pageFlip();
            if (instance && typeof instance.updateFrom === "function") {
                instance.updateFrom(0);
            } else if (instance && typeof instance.update === "function") {
                instance.update(); // fallback
            }
        }
    }, [zoomLevel]);

    const { width, height } = getFlipbookDimensions();


    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-cm-active-primary1"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex flex-column">
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                ref={inputRef}
                            />
                            <div
                                className="input-group-append bg-cm-light-primary1 p-1 rounded-end"
                                onClick={handleSearch}
                                style={{ cursor: "pointer" }}
                            >
                                <button className="btn btn-outline-primary" type="button">
                                    Search
                                </button>
                                {/* <BsSearch className="bg-cm-light-primary1 border-cm-light-primary1" /> */}
                            </div>
                        </div>
                    </div>
                    {downloadPdfResponse.isLoading ||
                        allPdfRecordResponse.isLoading ? (
                        <Loading />
                    ) : (
                        ""
                    )}
                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    scroll={{ x: 'max-content' }}
                    tableLayout="fixed"
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.PDF_LIBRARY:
                                    return totalPdfRecords;
                                default:
                                    return dataSource.length;
                            }
                        })(),
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>

            {/* PDF Viewer Modal */}
            {showPdfViewer && selectedPdf && (
                <div
                    className="modal show d-block"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                    onClick={closePdfViewer}
                >
                    <div
                        className="modal-dialog"
                        style={{
                            margin: "auto",
                            maxWidth: "100%",
                            width: "100%",
                            height: "100vh",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-content" style={{ height: "100vh" }}>
                            <div className="modal-header">
                                <div className="d-flex align-items-center">
                                    <div className="input-group me-2" style={{ width: "300px" }}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search in PDF..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") handleSearchInPdf();
                                            }}
                                            disabled={isLoadingPages}
                                        />
                                        <Button
                                            variant="outline-primary"
                                            onClick={handleSearchInPdf}
                                            disabled={isLoadingPages}
                                        >
                                            Search
                                        </Button>
                                    </div>
                                    {searchResults.length > 0 && (
                                        <div className="d-flex align-items-center me-2">
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={handlePrevSearchResult}
                                                disabled={currentSearchIndex === -1}
                                            >
                                                Prev
                                            </Button>
                                            <span className="mx-2">
                                                {currentSearchIndex + 1} of {searchResults.length}
                                            </span>
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={handleNextSearchResult}
                                                disabled={currentSearchIndex === -1}
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    )}
                                    <div className="d-flex align-items-center me-2">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={handleZoomOut}
                                            disabled={zoomLevel <= 0.5}
                                        >
                                            <BsZoomOut size={16} />
                                        </Button>
                                        <span className="mx-2">{Math.round(zoomLevel * 100)}%</span>
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={handleZoomIn}
                                            disabled={zoomLevel >= 3}
                                        >
                                            <BsZoomIn size={16} />
                                        </Button>
                                    </div>
                                    <Button
                                        variant="outline-secondary"
                                        className="me-2"
                                        onClick={toggleMaximize}
                                    >
                                        {isMaximized ? "Minimize" : "Maximize"}
                                    </Button>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={closePdfViewer}
                                ></button>
                            </div>
                            <div
                                className="modal-body p-0"
                                style={{
                                    // height: "calc(100vh - 100px)",
                                    height: `${baseHeight * zoomLevel}px`,
                                    overflowY: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                }}
                            >
                                {isLoadingPages ? (
                                    <div>Loading PDF pages...</div>
                                ) : pagesData.length > 0 ? (
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                        <HTMLFlipBook
                                            width={getFlipbookDimensions().width}
                                            height={getFlipbookDimensions().height}
                                            size="fixed"
                                            minWidth={getFlipbookDimensions().width}
                                            maxWidth={getFlipbookDimensions().width}
                                            minHeight={getFlipbookDimensions().height}
                                            maxHeight={getFlipbookDimensions().height}
                                            drawShadow={true}
                                            flippingTime={1000}
                                            usePortrait={true}
                                            startPage={currentFlipPage}
                                            className="flip-book"
                                            style={{
                                                flex: "none",
                                                margin: "0 auto",
                                                background: "#eee",
                                                border: "1px solid #ccc"
                                            }}
                                            ref={flipBookRef}
                                            useMouseEvents={true}
                                            onFlip={(e: any) => {
                                                setCurrentFlipPage(e.data);
                                            }}
                                            onInit={(data: any) => {
                                                console.log("FlipBook onInit fired!", data);
                                                const pageFlipInstance = flipBookRef.current.pageFlip();
                                                console.log("PageFlip instance in onInit:", pageFlipInstance);
                                            }}
                                            startZIndex={0}
                                            autoSize={false}
                                            maxShadowOpacity={0}
                                            showCover={false}
                                            mobileScrollSupport={false}
                                            clickEventForward={false}
                                            swipeDistance={0}
                                            showPageCorners={false}
                                            disableFlipByClick={false}
                                        >
                                            {pagesData.map((page, index) => (
                                                <div className="demoPage" key={index}
                                                    style={{
                                                        width: `${baseWidth}px`,
                                                        height: `${baseHeight}px`,
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        overflow: "hidden", // prevents spill
                                                        position: "relative",
                                                    }}>
                                                    <div
                                                        style={{
                                                            width: `${baseWidth}px`,
                                                            height: `${baseHeight}px`,
                                                            transform: `scale(${zoomLevel})`,
                                                            transformOrigin: "top left",
                                                            position: "relative",
                                                        }}
                                                    >
                                                        <img
                                                            src={page.image}
                                                            alt={`Page ${index + 1}`}
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "contain",
                                                                position: "absolute",
                                                                top: 0,
                                                                left: 0,
                                                                zIndex: 1,
                                                                // width: `${baseWidth * zoomLevel}px`,
                                                                // height: `${baseHeight * zoomLevel}px`,
                                                                // objectFit: "contain",
                                                                // display: "block",
                                                                // marginTop: "0px"
                                                            }}
                                                        />
                                                        {searchResults.includes(index) && searchQuery && (
                                                            <canvas
                                                                width={baseWidth}
                                                                height={baseHeight}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    left: 0,
                                                                    // width: `${getFlipbookDimensions().width}px`,
                                                                    // height: `${getFlipbookDimensions().height}px`,
                                                                    pointerEvents: "none",
                                                                }}
                                                                ref={(el) => (canvasRefs.current[index] = el)}
                                                            />
                                                        )}
                                                        <canvas
                                                            width={baseWidth}
                                                            height={baseHeight}
                                                            style={{
                                                                position: "absolute",
                                                                top: 0,
                                                                left: 0,
                                                                // width: `${baseWidth * zoomLevel}px`,
                                                                // height: `${baseHeight * zoomLevel}px`,
                                                                pointerEvents: "none",
                                                                opacity: 0.3,
                                                            }}
                                                            ref={(canvas) => {
                                                                if (canvas) {
                                                                    const ctx = canvas.getContext("2d");
                                                                    if (ctx) {
                                                                        ctx.fillStyle = "#3997ff";
                                                                        ctx.font = `${20 * zoomLevel}px Arial`;
                                                                        for (let x = 0; x < canvas.width; x += 100 * zoomLevel) {
                                                                            for (let y = 0; y < canvas.height; y += 100 * zoomLevel) {
                                                                                ctx.fillText("Kalki Agent", x, y);
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </HTMLFlipBook>
                                        <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                                            <Button
                                                variant="primary"
                                                onClick={handlePrevPage}
                                                disabled={currentFlipPage === 0}
                                            >
                                                Previous
                                            </Button>
                                            <span className="mt-1">
                                                Page {currentFlipPage + 1} of {pagesData.length}
                                            </span>
                                            <Button
                                                variant="primary"
                                                onClick={handleNextPage}
                                                disabled={currentFlipPage >= pagesData.length - 1}
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    </div>
                                ) : (
                                    <div>No pages loaded.</div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={closePdfViewer}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default PDFLibrary;